module.exports = __webpack_public_path__ + "img/analyser-complete.cd314fdb.svg";